<script setup>
  import { ref, computed, watch } from "vue";
  import { usePlanStore } from "@/stores/usePlanStore";
  import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";
  
  const planStore = usePlanStore();
  const emit = defineEmits(["close", "refresh"]);
  
  // ✅ Flag local pra “travar” atualizações enquanto confirma
  const isDeleting = ref(false);
  
  // ✅ Congela label (pra não mudar no meio)
  const frozenPlanLabel = ref("");
  
  // ✅ Congela ID (pra não deletar outro se planStore.idPlan mudar)
  const frozenPlanId = ref(null);
  
  function getCurrentPlanId() {
    return planStore?.idPlan ?? null;
  }
  
  function getCurrentPlanLabel() {
    const name =
      planStore?.selectedPlan?.planName ||
      planStore?.selectedPlan?.name ||
      planStore?.plan?.planName ||
      planStore?.plan?.name ||
      "";
  
    const id = getCurrentPlanId();
  
    return (name?.trim?.() || "") || (id ? `#${id}` : "");
  }
  
  function freezeSnapshot() {
    frozenPlanId.value = getCurrentPlanId();
    frozenPlanLabel.value = getCurrentPlanLabel();
  }
  
  // ✅ Mantém congelado atualizado ENQUANTO NÃO está deletando
  watch(
    () => [planStore?.idPlan, planStore?.selectedPlan?.planName, planStore?.selectedPlan?.name],
    () => {
      if (!isDeleting.value) freezeSnapshot();
    },
    { immediate: true }
  );
  
  const modalTitle = "Apagar Plano";
  
  const messageTitle = computed(() => {
    const label = frozenPlanLabel.value;
    return label
      ? `Você está prestes a apagar o plano "${label}".`
      : "Você está prestes a apagar este plano.";
  });
  
  const messageSubtitle = computed(() => "Esta ação não pode ser desfeita.");
  
  function buildErrorMessage(error) {
    return (
      error?.response?.data?.message ||
      error?.message ||
      "Não foi possível excluir este plano. Verifique se ele não está em uso por alguma assinatura."
    );
  }
  
  async function onConfirmDelete() {
    // ✅ congela ANTES de deletar (texto + alvo)
    freezeSnapshot();
    isDeleting.value = true;
  
    try {
      if (!frozenPlanId.value) {
        throw new Error("ID do plano inválido para exclusão.");
      }
  
      await planStore.deletePlanById(frozenPlanId.value);
    } catch (error) {
      isDeleting.value = false; // permite tentar novamente e voltar a atualizar snapshot
      throw new Error(buildErrorMessage(error)); // toast vem do DeleteConfirmModal
    }
  }
  
  function handleSuccess() {
    emit("refresh");
    emit("close");
  }
  </script>
  
  <template>
    <DeleteConfirmModal
      :show="true"
      :title="modalTitle"
      :messageTitle="messageTitle"
      :messageSubtitle="messageSubtitle"
      confirmText="Sim, apagar"
      cancelText="Cancelar"
      loadingText="Apagando..."
      :onConfirm="onConfirmDelete"
      @success="handleSuccess"
      @close="!isDeleting && emit('close')"
    />
  </template>
  